import { render, staticRenderFns } from "./e-menu-tags.vue?vue&type=template&id=1d99e3c2&scoped=true&lang=pug"
import script from "./e-menu-tags.vue?vue&type=script&lang=js"
export * from "./e-menu-tags.vue?vue&type=script&lang=js"
import style0 from "./e-menu-tags.vue?vue&type=style&index=0&id=1d99e3c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99e3c2",
  null
  
)

export default component.exports